import { appState } from '../js/state.js';


// Debugging confirmation
console.log('✅ Blog Master Page Builder loaded successfully!');

// 1) Build-and-cache the *static* master HTML (header+footer) exactly once:
let _staticMasterPromise = null;
let _staticMasterListenerToReAttach = [];
let _staticMasterLang = null; // Track the last language used

// Blog Master Page Builder
export async function buildMasterLayoutBlog() {
  console.log('🔄 Blog Master Page Builder - Starting to build master page');

  try {
      if (_staticMasterPromise && _staticMasterLang === appState.SiteLanguageCookie) {
      // 1) Dynamically import the layout utility
      const { registerEventListenerToAttach } = await import(
        /* webpackChunkName: "to-attach-event-listener-registry", webpackPrefetch: true  */
        '../js/to-attach-event-listener-registry.js'
      );

      // re-attach every one of your listeners:
      _staticMasterListenerToReAttach.forEach(initFn => registerEventListenerToAttach(initFn));

      return await _staticMasterPromise;
    }

      


    // 1) Dynamically import the layout utility
    const { getMasterLayoutContentByFolderPath } = await import(
      /* webpackChunkName: "build-manager-utils", webpackPrefetch: true  */
      '../js/build-manager-utils.js'
    );

    const masterLayoutTemplate = await getMasterLayoutContentByFolderPath(
      'layouts/master-layout-blog'
    );

    // 3) Dynamically import all header/footer components in parallel
    const [
      { buildComponentPreHeader, initComponentPreHeader },
      { buildComponentHeaderLinksShop, initComponentHeaderLinksShop },
      { buildComponentSelectLanguageTop, initComponentSelectLanguageTop },
      { buildComponentShipToCountryTop, initComponentShipToCountryTop },
      { buildComponentSelectCurrencyTop, initComponentSelectCurrencyTop },
      { buildComponentLoginUserOptionsTop, initComponentLoginUserOptionsTop },
      { buildComponentHeaderShop, initComponentHeaderShop },
      { buildComponentBlogTopNav, initComponentBlogTopNav },
      { buildComponentMainFooter, initComponentMainFooter },
      { buildComponentScrollToTop, initbuildComponentScrollToTop },

      //{ buildComponentPreHeader },
      //{ buildComponentHeaderLinksShop },
      //{ buildComponentSelectLanguageTop, initComponentSelectLanguageTop },
      //{ buildComponentShipToCountryTop },
      //{ buildComponentSelectCurrencyTop },
      //{ buildComponentLoginUserOptionsTop },
      //{ buildComponentHeaderShop },
      //{ buildComponentBlogTopNav },
      //{ buildComponentMainFooter },
      //{ buildComponentScrollToTop }
    ] = await Promise.all([
      import(
        /* webpackChunkName: "pre-header", webpackPrefetch: true  */ '../builders-components/header/pre-header.js'
      ),
      import(
        /* webpackChunkName: "header-links-shop", webpackPrefetch: true  */ '../builders-components/header/header-links-shop.js'
      ),
      import(
        /* webpackChunkName: "select-language-top", webpackPrefetch: true  */ '../builders-components/header/select-language-top.js'
      ),
      import(
        /* webpackChunkName: "ship-to-country-top", webpackPrefetch: true  */ '../builders-components/header/ship-to-country-top.js'
      ),
      import(
        /* webpackChunkName: "select-currency-top", webpackPrefetch: true  */ '../builders-components/header/select-currency-top.js'
      ),
      import(
        /* webpackChunkName: "login-user-options-top", webpackPrefetch: true  */ '../builders-components/header/login-user-options-top.js'
      ),
      import(
        /* webpackChunkName: "header-shop", webpackPrefetch: true  */ '../builders-components/header/header-shop.js'
      ),
      import(
        /* webpackChunkName: "blog-top-nav.js", webpackPrefetch: true  */ '../builders-components/blog/blog-top-nav.js'
      ),
      import(
        /* webpackChunkName: "main-footer", webpackPrefetch: true  */ '../builders-components/footer/main-footer.js'
      ),
      import(
        /* webpackChunkName: "scroll-to-top-button", webpackPrefetch: true  */ '../builders-components/scroll-to-top-button/scroll-to-top-button.js'
      ),
    ]);

    // 4) Build all components in parallel
    const [
      preHeaderContent,
      headerLinksContent,
      selectLanguageContent,
      shipToCountryContent,
      selectCurrencyContent,
      loginUserOptionsContent,
      headerContent,
      navBarContent,
      footerContent,
      scrollToTopContent,
    ] = await Promise.all([
      buildComponentPreHeader(),
      buildComponentHeaderLinksShop(),
      buildComponentSelectLanguageTop(),
      buildComponentShipToCountryTop(),
      buildComponentSelectCurrencyTop(),
      buildComponentLoginUserOptionsTop(),
      buildComponentHeaderShop(),
      buildComponentBlogTopNav(),
      buildComponentMainFooter(),
      buildComponentScrollToTop(),
    ]);

    // 5) Assemble header-links with nested placeholders
    const assembledHeaderLinks = headerLinksContent
      .replace('{{{ select-language-top }}}', selectLanguageContent)
      .replace('{{{ ship-to-country-top }}}', shipToCountryContent)
      .replace('{{{ select-currency-top }}}', selectCurrencyContent)
      .replace('{{{ login-user-options-top }}}', loginUserOptionsContent);

    // 6) Merge all parts into the master layout
    const result = masterLayoutTemplate
      .replace('{{{ pre-header }}}', preHeaderContent)
      .replace('{{{ header }}}', headerContent)
      .replace('{{{ header-horizontal-nav-bar-for-blog }}}', navBarContent)
      .replace('{{{ header-links }}}', assembledHeaderLinks)
      .replace('{{{ footer }}}', footerContent)
      .replace('{{{ scroll-to-top }}}', scrollToTopContent);

    // Cache the static master layout promise
      _staticMasterPromise = Promise.resolve(result);
      _staticMasterLang = appState.SiteLanguageCookie; 

    // add event listener to reattch
    _staticMasterListenerToReAttach = [
      initComponentPreHeader,
      initComponentHeaderLinksShop,
      initComponentSelectLanguageTop,
      initComponentShipToCountryTop,
      initComponentSelectCurrencyTop,
      initComponentLoginUserOptionsTop,
      initComponentHeaderShop,
      initComponentBlogTopNav,
      initComponentMainFooter,
        initbuildComponentScrollToTop,
    ];

    console.log('✅ Blog Master Page Builder - Master page built successfully');
    return result;
  } catch (error) {
    console.error('❌ Error building Blog master page content:', error);
    return 'Error loading Blog master page content.';
  }
}
